import React, { use, useEffect, useState } from "react";
import Dropzone from 'react-dropzone'
import axios from 'axios';
import { Origami, Sparkles, Zap, Trash2, AlertCircle, CheckCircle, X, Minus, Plus } from "lucide-react";
import { BlobSource, Input, ALL_FORMATS } from 'mediabunny';
import { io } from "socket.io-client";
import apiClient from '../ApiClient/ApiClient';
import { video } from "framer-motion/client";

export default function LeftPanel({ terima, hapus, ambilHasilGen, generateVideo, bukaModal, tutupModal, ambilHasilCheck, getFile, setFile, getDurasi, setDurasi, getInstruksi, setInstruksi, setTotalHistory, setArrHistory, listVideoSession, setListVideoSession, setIdSession, idSession, listVideoNames, listVideoDuration, refreshVideoList, setListVideoNames, outputResult, setOutputResult, inputDuration }) {
  const [typeCount, setTypeCount] = useState(0);
  const [notification, setNotification] = useState({ show: false, message: '', type: 'error' });
  const [uploadProgress, setUploadProgress] = useState({ 
    isUploading: false, 
    uploaded: 0, 
    total: 0,
    currentFile: null 
  });
  const [videoSessionThumbnails, setVideoSessionThumbnails] = useState([]);

  function formatBytes(bytes) {
    if (bytes < 1024) return bytes + ' Bytes';
    else if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(2) + ' KB';
    else if (bytes < 1024 * 1024 * 1024) return (bytes / (1024 * 1024)).toFixed(2) + ' MB';
    else return (bytes / (1024 * 1024 * 1024)).toFixed(6) + ' GB';
  }

  // const GenerateVideo = () => {
  //   const isitoken = `Bearer ${localStorage.getItem('token')}`
  //   let data = new FormData();
  //   if(fileTarget.length != 0) {
  //     fileTarget.map((item, index) => {
  //       data.append('videos', item);
  //     })
  //   }
  //   data.append('duration', duration);
  //   data.append('instructions', instruct);
  //   if(terima){
  //     data.append('ref_templates', terima);
  //   }
  //   data.append('crop_mode', "Original"); 


  //   let config = {
  //       method: 'post',
  //       maxBodyLength: Infinity,
  //       url: 'http://35.247.190.31:8643/video/generate',
  //           headers: { 
  //           'Authorization': isitoken, 
  //       },
  //       data : data
  //   };

  //   axios.request(config)
  //   .then((response) => {
  //       console.log(response.data.result);
  //       ambilHasilGen(response.data.result)
  //   })
  //   .catch((error) => {
  //       console.log(error);
  //   });
  // }



  const historyGenerate = () => {
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/video/session/byUserID`,
    };

    apiClient.request(config)
      .then((response) => {
        // console.log(response.data);
        setTotalHistory(response.data.total);
        setArrHistory((response.data.data_sessions).reverse())
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    historyGenerate()
  }, [])

  function gantiTitikJadiKoma(angka) {
    const bulat = Math.round(angka); // atau Math.floor/ceil jika perlu
    return new Intl.NumberFormat('id-ID', {
      maximumFractionDigits: 0 // pastikan tidak ada desimal
    }).format(bulat);
  }

  // Fungsi helper untuk menampilkan notifikasi
  const showNotification = (message, type = 'error') => {
    setNotification({ show: true, message, type });
  };

  // Auto-hide notification after 5 seconds
  useEffect(() => {
    if (notification.show) {
      const timer = setTimeout(() => {
        setNotification({ show: false, message: '', type: 'error' });
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [notification.show]);

  // Fungsi untuk delete video dari session
  const deleteVideoFromSession = async (filename, index) => {
    if (!idSession || idSession === "" || !filename) {
      showNotification("Cannot delete video: Invalid session or filename.", 'error');
      return;
    }

    let data = new FormData();

    let config = {
      method: 'delete',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/video/input?video_session=${idSession}&filename=${encodeURIComponent(filename)}`,
      data: data
    };

    try {
      await apiClient.request(config);
      
      // Update listVideoSession - hapus item yang dihapus
      if (listVideoSession && Array.isArray(listVideoSession)) {
        const updatedList = listVideoSession.filter((_, i) => i !== index);
        const updatedListNames = listVideoNames.filter((_, i) => i !== index);
        setListVideoSession(updatedList.length > 0 ? updatedList : null);
        setListVideoNames(updatedListNames);
        // Hapus thumbnail yang sesuai
        setVideoSessionThumbnails(prev => prev.filter((_, i) => i !== index));
      }

      // Connect socket.io setelah delete berhasil
      console.log('🔄 Connecting socket.io after video delete...');
      console.log('📋 Session ID:', idSession);
      console.log('📁 Deleted filename:', filename);
      
      const urlSocketIO = `${process.env.REACT_APP_WSS_URL}?session_id=${idSession}`;
      console.log('🔗 Socket URL:', urlSocketIO);
      
      const socket = io(urlSocketIO, {
        transports: ["websocket"]
      });

      // Socket event listeners dengan console.log
      socket.on('connect', () => {
        console.log(`✅ Socket connected for session after delete: ${idSession}`);
      });

      socket.on('disconnect', () => {
        console.log(`❌ Socket disconnected for session after delete: ${idSession}`);
      });

      socket.on('error', (error) => {
        console.error(`❌ Socket error for session ${idSession} after delete:`, error);
      });

      // Listen untuk event video-related (jika ada)
      socket.on('video_generate_status', (data) => {
        console.log(`🎥 Video status update after delete [${idSession}]:`, data);
      });

      socket.on('video_generate_data', (data) => {
        console.log(`📊 Video data update after delete [${idSession}]:`, data);
      });

      // Tampilkan notifikasi success
      showNotification(`Video "${filename}" has been successfully deleted.`, 'success');
    } catch (error) {
      console.error('Error deleting video:', error);
      showNotification("Failed to delete video. Please try again.", 'error');
    }
  };

  // Fungsi untuk generate random 7 digit number
  const generateRandomSessionId = () => {
    return Math.floor(1000000 + Math.random() * 9000000).toString();
  };

  // Fungsi untuk mendapatkan Content-Type berdasarkan file type
  const getContentType = (fileType) => {
    if (fileType.includes('mp4')) {
      return 'video/mp4';
    } else if (fileType.includes('mov') || fileType.includes('quicktime')) {
      return 'video/quicktime';
    } else if (fileType.includes('webm')) {
      return 'video/webm';
    }
    // Default fallback
    return 'video/mp4';
  };

  // Fungsi untuk upload video (2 API calls)
  const uploadVideoToGCS = async (fileItem, videoSession) => {
    try {
      // API Call 1: Get upload URL
      let data = new FormData();
      // Nama file sudah disanitasi di getFileWithMetadata (spasi menjadi _)
      data.append('filename', fileItem.name);
      data.append('video_session', videoSession);

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}/video/gcs/input`,
        data: data
      };

      const response1 = await apiClient.request(config);
      const uploadUrl = response1.data.upload_url;

      if (!uploadUrl) {
        throw new Error('Upload URL not found in response');
      }

      // API Call 2: Upload file to GCS
      const contentType = getContentType(fileItem.type);
      
      let config2 = {
        method: 'put',
        maxBodyLength: Infinity,
        url: uploadUrl,
        headers: {
          'Content-Type': contentType
        },
        data: fileItem.file // Binary file data
      };

      const response2 = await axios.request(config2);
      
      return {
        success: true,
        response: response2.data,
        videoSession: videoSession
      };
    } catch (error) {
      console.error('Error uploading video:', error);
      return {
        success: false,
        error: error.message || 'Upload failed',
        videoSession: videoSession
      };
    }
  };

  const CheckQuotaVideoGenerate = () => {
    // if(idSession == "" ) {
      
      // Validasi: cek apakah file target kosong
      if ((!getFile || getFile.length === 0) && !listVideoSession) {
        showNotification("Please upload at least one video file before generating.", 'error');
        return;
      }

      // Validasi: cek apakah instruksi/deskripsi kosong
      if (!getInstruksi || getInstruksi.trim() === "") {
        showNotification("Please provide instructions/description for video editing.", 'error');
        return;
      }

      // Validasi: cek apakah durasi sama dengan 0
      if (!getDurasi || getDurasi === 0) {
        showNotification("Please set video duration (must be greater than 0).", 'error');
        return;
      }

      // Validasi: input_duration harus lebih besar daripada output_duration
      const inputDurationValue = Math.floor(totalDuration);
      if (inputDurationValue < getDurasi) {
        console.log(inputDurationValue, getDurasi);
        showNotification("Input duration must be greater than output duration.", 'error');
        return;
      }

      if((getFile || listVideoSession) && getInstruksi && getDurasi) {

        // Upload videos to GCS
        if (getFile && getFile.length > 0 || listVideoSession && listVideoSession.length > 0) {
          // Generate random session ID untuk item pertama
          let videoSession = generateRandomSessionId();
          if(idSession == "") {
            videoSession = generateRandomSessionId();
          } else {
            videoSession = idSession;
          }
          setIdSession(videoSession)
          
          // Set upload progress state
          if(getFile.length > 0) {
            setUploadProgress({
              isUploading: true,
              uploaded: 0,
              total: getFile.length,
              currentFile: null
            });
          }
          
          // Upload setiap file secara sequential
          (async () => {
            if (getFile.length > 0) {
              for(let i = 0; i < getFile.length; i++) {
                console.log(`Uploading file ${i + 1}/${getFile.length}:`, getFile[i].name);
                
                // Update current file
                setUploadProgress(prev => ({
                  ...prev,
                  currentFile: getFile[i].name
                }));
                
                const result = await uploadVideoToGCS(getFile[i], videoSession);
                
                if (result.success) {
                  console.log(`Successfully uploaded: ${getFile[i].name}`, result);
                  // Update uploaded count
                  setUploadProgress(prev => ({
                    ...prev,
                    uploaded: prev.uploaded + 1,
                    currentFile: null
                  }));
                } else {
                  console.error(`Failed to upload: ${getFile[i].name}`, result.error);
                  showNotification(`Failed to upload ${getFile[i].name}: ${result.error}`, 'error');
                  // Still increment to show progress even if failed
                  setUploadProgress(prev => ({
                    ...prev,
                    uploaded: prev.uploaded + 1,
                    currentFile: null
                  }));
                }
              }
              
              // Upload complete
              setUploadProgress(prev => ({
                ...prev,
                isUploading: false,
                currentFile: null
              }));
            }
            
            // Show completion notification
            if (getFile.length > 0 ) {
              showNotification(`Successfully uploaded ${getFile.length} video(s).`, 'success');
            }
              // Open modal after upload completes
                bukaModal();
                let data = new FormData();
                // Convert arrays to JSON strings for FormData
                data.append('filenames', JSON.stringify(fileNamesArray))
                data.append('input_durations', JSON.stringify(fileDurationsArray))
                data.append('output_duration', getDurasi);
                data.append('instructions', getInstruksi);
                if (terima) {
                  data.append('ref_templates', terima);
                }
                // data.append('crop_mode', "Original");
                data.append('video_session', videoSession);

                data.append('num_variations', outputResult);

                let config = {
                  method: 'post',
                  maxBodyLength: Infinity,
                  url: `${process.env.REACT_APP_API_URL}/quota/check`,
                  data: data
                };
            
                apiClient.request(config)
                  .then((response) => {
                    // console.log(response);
                    ambilHasilCheck(gantiTitikJadiKoma(response.data.quota_usage))
                  })
                  .catch((error) => {
                    console.log(error);
                    tutupModal()
                  });
            
          })();
        }
      }


  }

  async function getVideoDurationz(file) {
    try {
      const input = new Input({
        formats: ALL_FORMATS,
        source: new BlobSource(file),
      });

      const duration = await input.computeDuration();
      return isFinite(duration) ? duration : null;
    } catch (error) {
      console.error('Error getting video duration with MediaBunny:', error);
      return null;
    }
  }

  // Fungsi untuk generate thumbnail dari video file
  const generateThumbnail = (videoFile) => {
    return new Promise((resolve) => {
      const videoUrl = URL.createObjectURL(videoFile);
      const video = document.createElement("video");
      const canvas = document.createElement("canvas");
      
      video.src = videoUrl;
      video.muted = true; // iOS often blocks autoplay/loading if not muted
      video.playsInline = true; // Crucial for background loading on iOS
      video.crossOrigin = "anonymous";
      video.currentTime = 0.1; // Seek to the first frame

      const captureFrame = () => {
        try {
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
          
          // Set the generated image as thumbnail
          const thumbnail = canvas.toDataURL("image/jpeg");
          
          // Cleanup
          URL.revokeObjectURL(videoUrl);
          video.remove();
          canvas.remove();
          
          resolve(thumbnail);
        } catch (error) {
          console.error('Error generating thumbnail:', error);
          // Cleanup on error
          URL.revokeObjectURL(videoUrl);
          video.remove();
          canvas.remove();
          resolve(null);
        }
      };

      const handleError = () => {
        console.error('Error loading video for thumbnail');
        URL.revokeObjectURL(videoUrl);
        video.remove();
        canvas.remove();
        resolve(null);
      };

      // Wait for the seek to complete before capturing
      video.addEventListener("seeked", captureFrame, { once: true });
      video.addEventListener("error", handleError, { once: true });
      
      // Trigger the load
      video.load();
    });
  };

  // Fungsi untuk generate thumbnail dari video URL
  const generateThumbnailFromUrl = (videoUrl) => {
    return new Promise((resolve) => {
      const video = document.createElement("video");
      const canvas = document.createElement("canvas");
      
      video.src = videoUrl;
      video.muted = true; // iOS often blocks autoplay/loading if not muted
      video.playsInline = true; // Crucial for background loading on iOS
      video.crossOrigin = "anonymous";
      video.currentTime = 0.1; // Seek to the first frame

      const captureFrame = () => {
        try {
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
          
          // Set the generated image as thumbnail
          const thumbnail = canvas.toDataURL("image/jpeg");
          
          // Cleanup
          video.remove();
          canvas.remove();
          
          resolve(thumbnail);
        } catch (error) {
          console.error('Error generating thumbnail from URL:', error);
          // Cleanup on error
          video.remove();
          canvas.remove();
          resolve(null);
        }
      };

      const handleError = () => {
        console.error('Error loading video for thumbnail from URL');
        video.remove();
        canvas.remove();
        resolve(null);
      };

      // Wait for the seek to complete before capturing
      video.addEventListener("seeked", captureFrame, { once: true });
      video.addEventListener("error", handleError, { once: true });
      
      // Trigger the load
      video.load();
    });
  };

  const getFileWithMetadata = async (file) => {
    let preview = URL.createObjectURL(file);
    let leng = null;
    let thumbnail = null;

    if (file.type.startsWith('video/')) {
      leng = await getVideoDurationz(file);
      thumbnail = await generateThumbnail(file);
    }

    // Sanitasi nama file: ganti spasi dan titik (kecuali titik ekstensi) dengan underscore
    let sanitizedFileName;
    const lastDotIndex = file.name.lastIndexOf('.');
    if (lastDotIndex > 0) {
      // Ada ekstensi, pisahkan nama dan ekstensi
      const nameWithoutExt = file.name.substring(0, lastDotIndex);
      const extension = file.name.substring(lastDotIndex);
      // Ganti spasi dan titik di bagian nama dengan underscore
      const sanitizedName = nameWithoutExt.replace(/[\s.]+/g, '_');
      sanitizedFileName = sanitizedName + extension;
    } else {
      // Tidak ada ekstensi, ganti spasi dan titik dengan underscore
      sanitizedFileName = file.name.replace(/[\s.]+/g, '_');
    }

    // Kembalikan objek yang berisi File asli + metadata
    return {
      file,        // ← File asli (untuk upload nanti)
      preview,
      leng,
      thumbnail,   // ← Thumbnail untuk poster
      // Salin properti umum agar mudah diakses di JSX
      name: sanitizedFileName,  // ← Nama sudah disanitasi (spasi menjadi _)
      size: file.size,
      type: file.type,
    };
  };

  const fileDuration = getFile?.reduce(
    (acc, item) => acc + (isFinite(item.leng) ? item.leng : 0),
    0
  ) || 0;
  
  // Array durasi untuk setiap video (dalam detik)
  // Jika ada listVideoDuration, masukkan di awal, lalu tambahkan durasi dari getFile
  const fileDurationsFromGetFile = getFile?.map((item) => {
    return isFinite(item.leng) ? Math.floor(item.leng) : 0;
  }) || [];
  
  const fileDurationsArray = [
    ...(listVideoDuration && listVideoDuration.length > 0 ? listVideoDuration : []),
    ...fileDurationsFromGetFile
  ];
  
  // Array nama untuk setiap video
  // Jika ada listVideoNames, masukkan di awal, lalu tambahkan nama dari getFile
  const fileNamesFromGetFile = getFile?.map((item) => {
    // Nama file sudah disanitasi di getFileWithMetadata (spasi menjadi _)
    return item.name || '';
  }) || [];
  
  const fileNamesArray = [
    ...(listVideoNames && listVideoNames.length > 0 ? listVideoNames : []),
    ...fileNamesFromGetFile
  ];
  
  // Pastikan inputDuration adalah number, bukan undefined atau null
  const inputDurationValue = typeof inputDuration === 'number' ? inputDuration : 0;
  const totalDuration = fileDuration + inputDurationValue;

  // Debug: log ketika inputDuration atau totalDuration berubah
  useEffect(() => {
    console.log('inputDurationValue = ', inputDurationValue)
    console.log('fileDuration = ', fileDuration)
    console.log('fileDurationsArray = ', fileDurationsArray)
    console.log('fileNamesArray = ', fileNamesArray)
    console.log('listVideoSession = ', listVideoSession)
    // console.log('LeftPanel - inputDuration:', inputDuration, 'type:', typeof inputDuration);
    // console.log('LeftPanel - fileDuration:', fileDuration);
    // console.log('LeftPanel - totalDuration:', totalDuration);
  }, [inputDuration, fileDuration, totalDuration, inputDurationValue, listVideoSession]);

  const handleDurasiChange = (e) => {
    const inputValue = e.target.value;

    // Jika input dikosongkan
    if (inputValue === '') {
      setDurasi(0);
      return;
    }

    let value = Number(inputValue);

    // Hitung batas maksimal berdasarkan totalDuration
    const maxAllowed = totalDuration >= 60 ? 60 : Math.floor(totalDuration);
    // Validasi & batasi nilai
    if (isNaN(value)) {
      value = 0;
    }
    if (value < 0) {
      value = 0;
    }
    if (value > maxAllowed) {
      value = maxAllowed;
    }

    setDurasi(value);
  };

  const maxValue = totalDuration < 60 && idSession == "" ? Math.floor(totalDuration) : 60;
  const progressPercent = maxValue > 0 ? (getDurasi / maxValue) * 100 : 0;


  useEffect(() => {
    console.log('LeftPanel - getFile:', getFile);
    console.log('LeftPanel - listVideoSession:', listVideoSession);
  }, [getFile, listVideoSession]);

  // Generate thumbnails untuk listVideoSession
  useEffect(() => {
    const generateThumbnails = async () => {
      if (listVideoSession && Array.isArray(listVideoSession) && listVideoSession.length > 0) {
        const thumbnails = await Promise.all(
          listVideoSession.map((videoUrl) => generateThumbnailFromUrl(videoUrl))
        );
        setVideoSessionThumbnails(thumbnails);
      } else {
        setVideoSessionThumbnails([]);
      }
    };

    generateThumbnails();
  }, [listVideoSession]);

  
  return (
    <div
      className="
        xs:flex-1
        md:w-[420px]
        rounded-3xl 
        p-6 
        space-y-8
        border border-white/10
        backdrop-blur-xl
        shadow-[0_10px_40px_rgba(0,0,0,0.35)]
        transition-all
        relative
      "
      style={{
        background:
          "linear-gradient(180deg, rgba(53,53,53,0.55) 0%, rgba(196,196,196,0.08) 100%)",
      }}
    >

      {/* LABEL COMPONENT */}
      <div className="flex w-[100%] justify-between">
        {sectionLabel("Raw Video")}

        {getFile.length != 0 && (
          <button 
            className="
              group
              relative
              w-max 
              bg-black/10 
              text-gray-400 
              border 
              border-white/10 
              hover:border-red-500/40
              hover:bg-red-500/10
              hover:text-red-400
              px-4 
              py-1.5 
              rounded-lg 
              font-medium 
              transition-all 
              duration-300
              overflow-hidden
              touch-manipulation
              select-none
              hover:scale-[1.05]
              active:scale-[0.95]
              focus-visible:outline-none
              focus-visible:ring-2
              focus-visible:ring-red-500/50
              focus-visible:ring-offset-2
              focus-visible:ring-offset-transparent
            " 
            onClick={() => { setFile([]) }} 
            title="You can remove this ref video"
          >
            {/* Ripple effect on click */}
            <span className="absolute inset-0 rounded-lg bg-red-500/0 active:bg-red-500/20 transition-colors duration-150 pointer-events-none" />
            
            {/* Subtle glow effect on hover */}
            <span className="absolute inset-0 rounded-lg bg-red-500/0 group-hover:bg-red-500/5 blur-sm transition-all duration-300 pointer-events-none" />
            
            {/* Content */}
            <div className="relative z-10 flex items-center gap-2">
              <Trash2 className="w-3.5 h-3.5 transition-all duration-300 group-hover:rotate-12 group-hover:scale-110" />
              <span>Clear Video</span>
            </div>
          </button>
        )}

      </div>
      <Dropzone
        onDrop={async (acceptedFiles) => {
          // Validasi: cek apakah ada nama file yang sama dengan yang sudah ada di session
          if (idSession && idSession !== "" && listVideoNames && listVideoNames.length > 0) {
            const duplicateFiles = [];
            
            acceptedFiles.forEach(file => {
              const fileName = file.name;
              const fileNameWithoutExt = fileName.replace(/\.[^/.]+$/, ""); // Nama tanpa ekstensi
              
              // Cek apakah nama file (dengan atau tanpa ekstensi) sudah ada di listVideoNames
              const isDuplicate = listVideoNames.some(existingName => {
                const existingNameWithoutExt = existingName.replace(/\.[^/.]+$/, "");
                return existingName === fileName || existingName === fileNameWithoutExt || 
                       existingNameWithoutExt === fileName || existingNameWithoutExt === fileNameWithoutExt;
              });
              
              if (isDuplicate) {
                duplicateFiles.push(fileName);
              }
            });
            
            if (duplicateFiles.length > 0) {
              showNotification(
                `Cannot upload duplicate videos. The following video(s) already exist in this session: ${duplicateFiles.join(", ")}`,
                'error'
              );
              return;
            }
          }
          
          const filesWithMeta = await Promise.all(
            acceptedFiles.map(getFileWithMetadata)
          );
          // Tambahkan video baru ke list yang sudah ada, bukan mengganti semua
          setFile([...getFile, ...filesWithMeta]);
        }}
        accept={{
          'video/mp4': ['.mp4'],
          'video/webm': ['.webm'],
          'video/quicktime': ['.mov'],
        }}
        multiple={true}
      >
        {({ getRootProps, getInputProps }) => (
          <section>
            <div
              className="
            border border-white/10
            rounded-2xl
            h-[200px]
            flex flex-col items-center justify-center
            text-gray-300
            text-[13px] 
            backdrop-blur
            hover:bg-white/5
            transition-all
            cursor-pointer
          "

              {...getRootProps()}
            >
              <input {...getInputProps()} />

              <div className="text-3xl mb-2 opacity-70">🎥</div>
              <p className="opacity-80">Upload a video you want to edit</p>
            </div>
          </section>

        )}
      </Dropzone>
   
      {listVideoSession && idSession != "" && (
        <>
          {listVideoSession.map((item, index) => {
            const filename = listVideoNames && listVideoNames[index] ? listVideoNames[index] : `video_${index + 1}`;
            const thumbnail = videoSessionThumbnails && videoSessionThumbnails[index] ? videoSessionThumbnails[index] : null;
            return (
              <div key={index} className="relative">
                <video className="rounded-2xl w-full" controls src={item} preload="metadata" playsInline poster={thumbnail || undefined} />
                <button
                  className="
                    group
                    absolute 
                    top-2 
                    right-2 
                    bg-gradient-to-br from-red-500 to-red-600
                    hover:from-red-500 
                    hover:to-red-700
                    active:from-red-500
                    active:to-red-800
                    text-white 
                    rounded-full 
                    w-9 h-9 
                    md:w-10 md:h-10 
                    flex 
                    items-center 
                    justify-center 
                    transition-all 
                    duration-300
                    shadow-lg
                    hover:shadow-xl
                    hover:shadow-red-500/50
                    hover:scale-110
                    active:scale-95
                    z-10
                    overflow-hidden
                    touch-manipulation
                    select-none
                    border-2
                    border-red-400/30
                    hover:border-red-300/50
                    focus-visible:outline-none
                    focus-visible:ring-2
                    focus-visible:ring-red-500/50
                    focus-visible:ring-offset-2
                    focus-visible:ring-offset-transparent
                  "
                  onClick={() => deleteVideoFromSession(filename, index)}
                  title="Delete this video"
                  aria-label="Delete this video"
                >
                  {/* Ripple effect on click */}
                  <span className="absolute inset-0 rounded-full bg-white/0 active:bg-white/30 transition-all duration-200 pointer-events-none" />
                  
                  {/* Glow effect on hover */}
                  <span className="absolute inset-0 rounded-full bg-red-400/0 group-hover:bg-red-400/20 blur-md transition-all duration-300 pointer-events-none" />
                  
                  {/* Pulsing ring effect */}
                  <span className="absolute inset-0 rounded-full border-2 border-white/0 group-hover:border-white/30 group-hover:animate-ping pointer-events-none" />
                  
                  {/* Icon content */}
                  <Trash2 className="relative z-10 w-4 h-4 md:w-5 md:h-5 transition-all duration-300 group-hover:rotate-12 group-hover:scale-110" />
                </button>
              </div>
            );
          })}
        </>
      )}
      {getFile && (
        <>
          {getFile.map((item, index) => (
            <div key={index} className="relative">
              <video className="rounded-2xl w-full" controls src={`${item.preview}`} preload="metadata" playsInline poster={item.thumbnail || undefined} />
              <button
                className="
                  group
                  absolute 
                  top-2 
                  right-2 
                  bg-gradient-to-br from-red-500 to-red-600
                  hover:from-red-500 
                  hover:to-red-700
                  active:from-red-500
                  active:to-red-800
                  text-white 
                  rounded-full 
                  w-9 h-9 
                  md:w-10 md:h-10 
                  flex 
                  items-center 
                  justify-center 
                  transition-all 
                  duration-300
                  shadow-lg
                  hover:shadow-xl
                  hover:shadow-red-500/50
                  hover:scale-110
                  active:scale-95
                  z-10
                  overflow-hidden
                  touch-manipulation
                  select-none
                  border-2
                  border-red-400/30
                  hover:border-red-300/50
                  focus-visible:outline-none
                  focus-visible:ring-2
                  focus-visible:ring-red-500/50
                  focus-visible:ring-offset-2
                  focus-visible:ring-offset-transparent
                "
                onClick={() => {
                  // Hapus video tertentu dari list
                  const newFileList = getFile.filter((_, i) => i !== index);
                  setFile(newFileList);
                }}
                title="Remove this video"
                aria-label="Remove this video"
              >
                {/* Ripple effect on click */}
                <span className="absolute inset-0 rounded-full bg-white/0 active:bg-white/30 transition-all duration-200 pointer-events-none" />
                
                {/* Glow effect on hover */}
                <span className="absolute inset-0 rounded-full bg-red-400/0 group-hover:bg-red-400/20 blur-md transition-all duration-300 pointer-events-none" />
                
                {/* Pulsing ring effect */}
                <span className="absolute inset-0 rounded-full border-2 border-white/0 group-hover:border-white/30 group-hover:animate-ping pointer-events-none" />
                
                {/* Icon content */}
                <Trash2 className="relative z-10 w-4 h-4 md:w-5 md:h-5 transition-all duration-300 group-hover:rotate-12 group-hover:scale-110" />
              </button>
            </div>
          ))}
        </>
      )}
      {
        <>
          {(getFile || (listVideoSession && listVideoSession.length != 0)) &&
            (
              <p className="font-medium">
                All Durations: {
                  listVideoSession && listVideoSession.length > 0 && inputDurationValue === 0 ? (
                    <span>
                      {Math.floor(fileDuration / 60)}m {Math.floor(fileDuration % 60)}s
                      <span className="text-yellow-400 animate-pulse ml-2">(+ calculating...)</span>
                    </span>
                  ) : (
                    `${Math.floor(totalDuration / 60)}m ${Math.floor(totalDuration % 60)}s`
                  )
                }
              </p>
            )
          }
        </>
      }


      {/* DESCRIPTION BOX */}
      <div className="space-y-1">
        <textarea
          placeholder="Describe how to edit the video: add, replace, remove elements, or restyle."
          className="
            w-full 
            h-[120px]
            bg-black/10
            backdrop-blur
            border border-white/10
            rounded-xl
            p-3 
            text-[13px]
            text-gray-200
            placeholder:text-gray-400
            leading-[1.35]
            resize-none
            tracking-tight
            focus:outline-none
            focus:border-[#044250]/60
            transition-all
          "
          value={getInstruksi}
          onChange={(event) => { setTypeCount((event.target.value).length); setInstruksi(event.target.value) }}
          maxLength={2000}
        />

        <p className="text-[11px] text-gray-500 text-right">{typeCount}/2000</p>
      </div>

      {terima && (
        <div className="flex flex-col max">
          {sectionLabel("Reference Video")}

          <button className="w-max bg-black/10 text-gray-400 border border-white/10 hover:bg-white/5 px-4 py-1.5 rounded-lg font-medium transition-all " style={{ marginTop: '12px' }} onClick={hapus} title="You can remove this ref video">
            {terima}
          </button>
        </div>
      )}

      {/* DURATION */}
      {sectionLabel("Video Duration (Second)")}

      <div className="flex items-center gap-4">
        <input
          type="range"
          min={0}
          max={totalDuration < 60 && idSession == "" ? Math.floor(totalDuration) : 60}
          value={getDurasi}
          onChange={(e) => setDurasi(Number(e.target.value))}
          className="
            flex-1
            h-1.5
            rounded-full
            appearance-none
            cursor-pointer
            custom-range
          "
          style={{
            background: `linear-gradient(to right, #00FFD1 ${progressPercent}%, rgba(255,255,255,0.25) ${progressPercent}%)`,
          }}
        />

        {/* VALUE BOX */}
        {/* <div
          className="
      w-6 h-6
      flex items-center justify-center
      rounded
      border border-white/20
      bg-black/40
      text-white text-xs font-medium
    "
      p-2   10          {getDurasi}
        </div> */}

        <input type="number" inputMode="numeric" // tampilkan keyboard angka di mobile
          pattern="[0-9]*" className="no-spinner px-2 w-max h-6 flex items-center justify-center rounded border border-white/20 bg-black/40 text-white text-xs font-medium" value={getDurasi ?? ''} onChange={handleDurasiChange} min={0} max={totalDuration < 60 ? Math.floor(totalDuration) : 60} />
      </div>

      {/* RESULT OUTPUT SLIDER (1-9) */}
      {sectionLabel("Result Output")}
      
      <div className="relative">
        {/* Slider Container */}
        <div className="relative w-full">
          {/* Track Background */}
          <div className="relative w-full h-2.5 bg-white/10 rounded-full mb-10">
            {/* Active Track */}
            <div 
              className="absolute h-2.5 bg-gradient-to-r from-[#00FFD1] to-[#00B8A3] rounded-full transition-all duration-300 ease-out shadow-lg shadow-[#00FFD1]/30"
              style={{
                width: `${((outputResult - 1) / 8) * 100}%`,
                left: '0%'
              }}
            ></div>
            
            {/* Indicator Marks */}
            <div className="absolute inset-0 flex justify-between items-center pointer-events- mt-[11px]">
              {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((value) => (
                <div
                  key={value}
                  className="relative flex flex-col items-center"
                >
                  {/* Dot Indicator */}
                  <div
                    className={`
                      w-3 h-3
                      rounded-full
                      transition-all duration-300
                      -translate-y-1/2
                      ${outputResult === value
                        ? 'bg-[#00FFD1] shadow-lg shadow-[#00FFD1]/50 scale-150'
                        : outputResult > value
                        ? 'bg-[#00FFD1]/70 scale-100'
                        : 'bg-white/40 scale-100'
                      }
                    `}
                  ></div>
                  
                  {/* Value Label Below */}
                  <span 
                    className={`
                      absolute top-full mt-[4px] text-xs font-semibold whitespace-nowrap transition-all duration-300
                      ${outputResult === value
                        ? 'text-[#00FFD1] scale-110 font-bold'
                        : 'text-gray-400'
                      }
                    `}
                  >
                    {value}
                  </span>
                </div>
              ))}
            </div>
          </div>
          
          {/* Slider Input - Functional but styled */}
          <div className="relative">
            <input
              type="range"
              min={1}
              max={9}
              step={1}
              value={outputResult}
              onChange={(e) => setOutputResult(Number(e.target.value))}
              className="
                w-full
                h-3
                rounded-full
                appearance-none
                cursor-pointer
                bg-transparent
                slider-range
              "
              style={{
                background: `linear-gradient(to right, #00FFD1 0%, #00FFD1 ${((outputResult - 1) / 8) * 100}%, rgba(255,255,255,0.1) ${((outputResult - 1) / 8) * 100}%, rgba(255,255,255,0.1) 100%)`
              }}
            />
          </div>
        </div>
        
        {/* Selected Value Display with +/- Buttons */}
        <div className="mt-6 flex items-center justify-center gap-3">
          {/* Minus Button */}
          <button
            onClick={() => setOutputResult(Math.max(1, outputResult - 1))}
            disabled={outputResult <= 1}
            className={`
              group
              relative
              w-12 h-12
              rounded-xl
              flex items-center justify-center
              transition-all duration-300
              touch-manipulation
              select-none
              border-2
              ${outputResult <= 1
                ? 'bg-white/5 border-white/10 cursor-not-allowed opacity-50'
                : 'bg-white/10 border-white/20 hover:bg-white/15 hover:border-[#00FFD1]/50 hover:scale-110 active:scale-95 cursor-pointer'
              }
            `}
            aria-label="Decrease result output"
            title="Decrease (Min: 1)"
          >
            {/* Glow effect on hover */}
            {outputResult > 1 && (
              <span className="absolute inset-0 rounded-xl bg-[#00FFD1]/0 group-hover:bg-[#00FFD1]/10 blur-md transition-all duration-300 pointer-events-none" />
            )}
            
            <Minus 
              className={`
                w-5 h-5 transition-all duration-300
                ${outputResult <= 1
                  ? 'text-gray-500'
                  : 'text-gray-300 group-hover:text-[#00FFD1] group-hover:scale-110'
                }
              `}
              strokeWidth={3}
            />
          </button>
          
          {/* Value Display */}
          <div className="px-6 py-3 rounded-xl bg-gradient-to-r from-[#00FFD1]/15 via-[#00FFD1]/8 to-[#00FFD1]/15 border border-[#00FFD1]/40 backdrop-blur-sm shadow-xl min-w-[120px] text-center">
            <span className="text-sm text-gray-300 font-medium">Result: </span>
            <span className="text-2xl font-bold text-[#00FFD1] drop-shadow-[0_0_10px_rgba(0,255,209,0.6)]">{outputResult}</span>
          </div>
          
          {/* Plus Button */}
          <button
            onClick={() => setOutputResult(Math.min(9, outputResult + 1))}
            disabled={outputResult >= 9}
            className={`
              group
              relative
              w-12 h-12
              rounded-xl
              flex items-center justify-center
              transition-all duration-300
              touch-manipulation
              select-none
              border-2
              ${outputResult >= 9
                ? 'bg-white/5 border-white/10 cursor-not-allowed opacity-50'
                : 'bg-white/10 border-white/20 hover:bg-white/15 hover:border-[#00FFD1]/50 hover:scale-110 active:scale-95 cursor-pointer'
              }
            `}
            aria-label="Increase result output"
            title="Increase (Max: 9)"
          >
            {/* Glow effect on hover */}
            {outputResult < 9 && (
              <span className="absolute inset-0 rounded-xl bg-[#00FFD1]/0 group-hover:bg-[#00FFD1]/10 blur-md transition-all duration-300 pointer-events-none" />
            )}
            
            <Plus 
              className={`
                w-5 h-5 transition-all duration-300
                ${outputResult >= 9
                  ? 'text-gray-500'
                  : 'text-gray-300 group-hover:text-[#00FFD1] group-hover:scale-110'
                }
              `}
              strokeWidth={3}
            />
          </button>
        </div>
      </div>

      {/* ASPECT RATIO */}
      {/* {sectionLabel("Aspect Ratio")} */}

      {/* <RadioGroup name="ratio" options={["Original", "Landscape (9:16)"]} getState={setRatio} /> */}

      {/* MODEL */}
      {/* {sectionLabel("Model")}

      <RadioGroup name="model" options={["Crop", "Padding"]} getState={setMode} /> */}

      {/* NOTIFICATION TOAST */}
      {notification.show && (
        <div 
          className={`
            w-full
            mb-4
            px-4
            py-3
            rounded-xl
            shadow-2xl
            backdrop-blur-md
            border
            transition-all
            duration-300
            transform
            relative
            overflow-hidden
            ${
              notification.type === 'error'
                ? 'bg-gradient-to-r from-red-500/95 via-red-600/95 to-red-500/95 border-red-400/60 text-white'
                : 'bg-gradient-to-r from-green-500/95 via-green-600/95 to-green-500/95 border-green-400/60 text-white'
            }
            ${
              notification.show 
                ? 'opacity-100 translate-y-0 scale-100' 
                : 'opacity-0 -translate-y-4 scale-95 pointer-events-none'
            }
          `}
          style={{
            animation: 'slideDownFade 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
            boxShadow: notification.type === 'error' 
              ? '0 20px 40px rgba(239, 68, 68, 0.3), 0 0 20px rgba(239, 68, 68, 0.2)' 
              : '0 20px 40px rgba(34, 197, 94, 0.3), 0 0 20px rgba(34, 197, 94, 0.2)'
          }}
        >
          {/* Content */}
          <div className="relative flex items-start gap-3">
            {/* Icon */}
            <div className="flex-shrink-0 mt-0.5">
              {notification.type === 'error' ? (
                <AlertCircle className="w-5 h-5 animate-pulse" />
              ) : (
                <CheckCircle className="w-5 h-5" />
              )}
            </div>
            
            {/* Message */}
            <div className="flex-1">
              <p className="text-sm font-medium leading-relaxed">
                {notification.message}
              </p>
            </div>
            
            {/* Close button */}
            <button
              onClick={() => setNotification({ show: false, message: '', type: 'error' })}
              className="
                flex-shrink-0
                p-1
                rounded-lg
                hover:bg-white/20
                transition-all
                duration-200
                active:scale-95
              "
              aria-label="Close notification"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
          
          {/* Progress bar untuk auto-hide */}
          <div 
            className={`
              w-full h-1 rounded-b-xl mt-2
              ${notification.type === 'error' ? 'bg-red-300/50' : 'bg-green-300/50'}
            `}
            style={{
              position: 'relative',
              overflow: 'hidden'
            }}
          >
            <div 
              className={`
                h-full rounded-b-xl
                ${notification.type === 'error' ? 'bg-red-300' : 'bg-green-300'}
              `}
              style={{
                animation: 'shrinkWidth 5s linear forwards',
                width: '100%'
              }}
            />
          </div>
        </div>
      )}

      {/* UPLOAD PROGRESS INDICATOR */}
      {uploadProgress.isUploading && uploadProgress.total > 0 && (
        <div className="
          w-full
          bg-black/20
          backdrop-blur
          border border-white/10
          rounded-xl
          p-4
          space-y-2
        ">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <svg 
                className="animate-spin h-4 w-4 text-[#00FFD1]" 
                xmlns="http://www.w3.org/2000/svg" 
                fill="none" 
                viewBox="0 0 24 24"
              >
                <circle 
                  className="opacity-25" 
                  cx="12" 
                  cy="12" 
                  r="10" 
                  stroke="currentColor" 
                  strokeWidth="4"
                ></circle>
                <path 
                  className="opacity-75" 
                  fill="currentColor" 
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
              <span className="text-sm text-gray-300 font-medium">
                Uploading videos...
              </span>
            </div>
            <span className="text-sm text-[#00FFD1] font-semibold">
              {uploadProgress.uploaded} / {uploadProgress.total}
            </span>
          </div>
          
          {/* Progress Bar */}
          <div className="w-full h-2 bg-white/10 rounded-full overflow-hidden">
            <div 
              className="h-full bg-gradient-to-r from-[#00FFD1] to-[#00B8A3] transition-all duration-300 ease-out"
              style={{ width: `${(uploadProgress.uploaded / uploadProgress.total) * 100}%` }}
            ></div>
          </div>

          {/* Current File */}
          {uploadProgress.currentFile && (
            <p className="text-xs text-gray-400 truncate">
              Uploading: {uploadProgress.currentFile}
            </p>
          )}
        </div>
      )}

      {/* GENERATE BUTTON */}
      <button
        className={`
          group
          relative
          w-full 
          py-3 
          rounded-xl 
          text-white
          font-semibold
          tracking-tight
          text-[15px]
          mt-3
          border
          transition-all 
          duration-300
          overflow-hidden
          touch-manipulation
          select-none
          focus-visible:outline-none
          focus-visible:ring-2
          focus-visible:ring-offset-2
          focus-visible:ring-offset-transparent
          ${
            uploadProgress.isUploading
              ? 'bg-gradient-to-r from-gray-500/20 via-gray-500/15 to-gray-500/20 border-gray-500/30 cursor-not-allowed opacity-50'
              : 'bg-gradient-to-r from-[#00FFD1]/20 via-[#00FFD1]/15 to-[#00FFD1]/20 border-[#00FFD1]/30 hover:border-[#00FFD1]/50 hover:bg-gradient-to-r hover:from-[#00FFD1]/30 hover:via-[#00FFD1]/25 hover:to-[#00FFD1]/30 hover:shadow-lg hover:shadow-[#00FFD1]/20 hover:scale-[1.02] active:scale-[0.98] focus-visible:ring-[#00FFD1]/50'
          }
        `}
        onClick={() => { CheckQuotaVideoGenerate() }}
        disabled={uploadProgress.isUploading}
      >
        {/* Animated gradient sweep */}
        {!uploadProgress.isUploading && (
          <span 
            className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 -translate-x-full group-hover:translate-x-full"
            style={{transition: 'transform 0.8s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.4s ease-in-out'}}
          />
        )}
        
        {/* Ripple effect on click */}
        {!uploadProgress.isUploading && (
          <span className="absolute inset-0 rounded-xl bg-white/0 active:bg-white/15 transition-colors duration-150 pointer-events-none" />
        )}
        
        {/* Glow effect */}
        {!uploadProgress.isUploading && (
          <span className="absolute inset-0 rounded-xl bg-[#00FFD1]/0 group-hover:bg-[#00FFD1]/10 blur-md transition-all duration-500 pointer-events-none" />
        )}
        
        {/* Shimmer effect */}
        {!uploadProgress.isUploading && (
          <span className="absolute inset-0 -skew-x-12 bg-gradient-to-r from-transparent via-white/20 to-transparent opacity-0 group-hover:opacity-100 group-hover:animate-shimmer pointer-events-none" />
        )}
        
        {/* Content */}
        <div className="relative z-10 flex items-center justify-center gap-2">
          {uploadProgress.isUploading ? (
            <>
              <svg 
                className="animate-spin h-4 w-4 text-gray-400" 
                xmlns="http://www.w3.org/2000/svg" 
                fill="none" 
                viewBox="0 0 24 24"
              >
                <circle 
                  className="opacity-25" 
                  cx="12" 
                  cy="12" 
                  r="10" 
                  stroke="currentColor" 
                  strokeWidth="4"
                ></circle>
                <path 
                  className="opacity-75" 
                  fill="currentColor" 
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
              <span className="text-gray-400">Uploading...</span>
            </>
          ) : (
            <>
              <Zap className="w-4 h-4 transition-all duration-300 group-hover:rotate-12 group-hover:scale-110 group-hover:text-[#00FFD1]" />
              <span className="transition-colors duration-300 group-hover:text-[#00FFD1]">Generate</span>
            </>
          )}
        </div>
      </button>

    </div>
  );
}

/* -------------------------------------------------- */
/* SMALL UTILITY COMPONENTS                           */
/* -------------------------------------------------- */

function sectionLabel(title) {
  return (
    <span
      className="
        inline-block 
        text-[12px] font-medium
        text-white
        bg-[#044250]
        px-3 py-1 
        rounded-full
        tracking-tight
        w-max
        content-center
        h-max
      "
    >
      {title}
    </span>
  );
}

function RadioGroup({ name, options, getState }) {
  return (
    <div className="flex items-center gap-6 text-[13px] text-gray-200">
      {options.map((label, index) => (
        <label key={index} className="flex items-center gap-2 cursor-pointer">
          {/* Input radio — tetap ada, tapi tidak terlihat */}
          <input
            type="radio"
            name={name}
            className="peer sr-only" // <-- sr-only lebih aman daripada hidden/opacity-0
            onChange={() => { getState(label) }}
          />

          <span className="custom-radio"></span>
          <span className="text-white">{label}</span>
        </label>
      ))}
    </div>
  );
}

